import { parseJSON } from 'helpers/safetyJSON';
import { experimentDuck } from '../duck';

export const setExperiment = (expCookie, initialValue) =>
  function* ({ cookies }) {
    const cookiesValue = cookies.get(expCookie);

    if (cookiesValue || initialValue) {
      yield experimentDuck.set(
        cookiesValue ? parseJSON(cookiesValue) : initialValue,
      );
    }
  };
